import { render, staticRenderFns } from "./GiftBoxIcon.vue?vue&type=template&id=57d36042&scoped=true"
import script from "./GiftBoxIcon.vue?vue&type=script&lang=js"
export * from "./GiftBoxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d36042",
  null
  
)

export default component.exports